import Vue from "vue";
import VueRouter from "vue-router";
import Home from '../pages/Home.vue'
import Company from '../pages/Company.vue'
import Reports from '../pages/Reports.vue'
import Report from '../pages/Report.vue'
import ExportReport from '../pages/ExportReport.vue'
import Export from '../pages/Export.vue'
import common from "@/util/common";
import _co from "@/util/const";
import Req from "@/util/request";


const Login = (r) =>
    require.ensure([], () => r(require("../pages/Login.vue")), "Login");
const DataCompare = (r) =>
    require.ensure([], () => r(require("../pages/DataCompare.vue")), "DataCompare");
const ExportDataCompare = (r) =>
    require.ensure([], () => r(require("../pages/ExportDataCompare.vue")), "ExportDataCompare");    
const ChoosePage = (r) =>
    require.ensure([], () => r(require("../pages/ChoosePage.vue")), "ChoosePage");
const OptionsPage = (r) =>
    require.ensure([], () => r(require("../pages/OptionsPage.vue")), "OptionsPage");
const SubIndustry = (r) =>
    require.ensure([], () => r(require("../pages/SubIndustry.vue")), "SubIndustry");
const EventList = (r) =>
    require.ensure([], () => r(require("../pages/EventList.vue")), "EventList");
const Warnings = (r) =>
    require.ensure([], () => r(require("../pages/Warnings.vue")), "Warnings");
const EnterpriseDistribution = (r) =>
    require.ensure([], () => r(require("../pages/EnterpriseDistribution.vue")), "EnterpriseDistribution");
const EnterpriseDistributionDetail = (r) =>
    require.ensure([], () => r(require("../pages/EnterpriseDistributionDetail.vue")), "EnterpriseDistributionDetail");    
const ArticleList = (r) =>
    require.ensure([], () => r(require("../pages/ArticleList.vue")), "ArticleList");
const CreateReport = (r) =>
    require.ensure([], () => r(require("../pages/CreateReport.vue")), "CreateReport");

const RankChoosePage = (r) =>
    require.ensure([], () => r(require("../pages/RankChoosePage.vue")), "RankChoosePage");

const Rank = (r) =>
    require.ensure([], () => r(require("../pages/Rank.vue")), "Rank");

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name === "NavigationDuplicated") {
            //吃掉重复点击单一路径导致的路由报错
            return;
        }
        throw err;
    })
};
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: _co.siteConfig.navBarTitle,
            requireAuth: false
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            title: '登录',
            requireAuth: false
        }
    },
    {
        path: '/subindustry/:name',
        name: 'SubIndustry',
        component: SubIndustry,
        meta: {
            title: _co.siteConfig.navBarTitle,
            requireAuth: false
        }
    },
    {
        path: '/company/:name',
        name: 'Company',
        component: Company,
        meta: {
            title: _co.siteConfig.navBarTitle,
            requireAuth: false
        }
    },
    {
        path: '/compare',
        name: 'DataCompare',
        component: DataCompare,
        meta: {
            title: '数据对比分析',
            requireAuth: false
        }
    },
    {
        path: '/exportCompare',
        name: 'ExportDataCompare',
        component: ExportDataCompare,
        meta: {
            title: '数据对比分析',
            requireAuth: false
        }
    },
    {
        path: '/choosePage',
        name: 'ChoosePage',
        component: ChoosePage,
        meta: {
            title: '数据对比',
            requireAuth: false
        }
    },
    {
        path: '/enterpriseDistribution',
        name: 'EnterpriseDistribution',
        component: EnterpriseDistribution,
        meta: {
            title: '企业分布',
            requireAuth: false
        },
    },
    {
        path: '/enterpriseDistribution/detail',
        name: 'EnterpriseDistributionDetail',
        component: EnterpriseDistributionDetail,
        meta: {
            title: '企业分布详情',
            requireAuth: false
        },
    },
    {
        path: '/optionsPage',
        name: 'OptionsPage',
        component: OptionsPage,
        meta: {
            title: '行业列表',
            requireAuth: false
        }
    },
    {
        path: '/eventList',
        name: 'EventList',
        component: EventList,
        meta: {
            title: '事件列表',
            requireAuth: false
        }
    },
    {
        path: '/warnings',
        name: 'Warnings',
        component: Warnings,
        meta: {
            title: '预警通知',
            requireAuth: false
        }
    },
    {
        path: '/articleList',
        name: 'ArticleList',
        component: ArticleList,
        meta: {
            title: '焦点报道',
            requireAuth: false
        }
    },
    {
        path: '/createReport',
        name: 'CreateReport',
        component: CreateReport,
        meta: {
            title: '创建报告',
            requireAuth: false
        }
    },
    {
        path: '/reports',
        name: 'Reports',
        component: Reports,
        meta: {
            title: '报告列表',
            requireAuth: false
        }
    },
    {
        path: '/reports/:id',
        name: 'Report',
        component: Report,
        meta: {
            title: '',
            requireAuth: false
        }
    },
    {
        path: '/exportReports/:id',
        name: 'ExportReport',
        component: ExportReport,
        meta: {
            title: '',
            requireAuth: false
        }
    },
    {
        path: '/export',
        name: 'Export',
        component: Export,
        meta: {
            title: '导出',
            requireAuth: false
        }  
    },
    {
        path: '/rankChoosePage',
        name: 'RankChoosePage',
        component: RankChoosePage,
        meta: {
            title: '智能榜单',
            requireAuth: false
        }
    },
    {
        path: '/rank',
        name: 'Rank',
        component: Rank,
        meta: {
            title: '智能榜单',
            requireAuth: false
        }
    },
];

const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    },
    routes
});


router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    if(to.name == "Login")
        return next();

    let token = common.getCookie("xinhuaToken");
    let user = localStorage.getItem('xinhuaUser');
    if (!token) {
        // console.log("not found token");
        localStorage.removeItem('xinhuaUser');
        return next()
    }
    if (token && !user) {
        Req.userInfo()
            .then(resp => {
                if (resp && resp.user)
                    localStorage.setItem("xinhuaUser", JSON.stringify(resp.user));

                return next();
            }).catch(e => {
            localStorage.removeItem('xinhuaUser');
            console.log("get user err:", e);
            common.removeToken()
        })
        return next()
    } else {
        return next()
    }

});

export default router;